import { encode, decode } from 'qss';
import { getErrorByCode } from '@commercetools/sdk-middleware-http';

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

var MANAGE_PROJECT = 'manage_project';
var DEFAULT_AUTH_TYPE = 'Basic';
var EXPIRATION_OFFSET = 2 * 60 * 60 * 1000; // 2 hours

var _excluded = ["message"];
var SdkAuth = /*#__PURE__*/function () {
  // Set flowtype annotations

  /**
   * Sample configuration object:
   * {
   *   "host": "https://auth.commercetools.com",
   *   "projectKey": "sample-project",
   *   "disableRefreshToken": false,
   *   "credentials": {
   *     "clientId": "sampleClient",
   *     "clientSecret": "sampleSecret"
   *   },
   *   "scopes": [
   *     "view_products:{project-key}"
   *   ],
   *   "fetch": function // implementation of a fetch method
   * }
   * @param config
   */
  function SdkAuth(config) {
    _classCallCheck(this, SdkAuth);
    // validate config properties
    SdkAuth._checkRequiredConfiguration(config);
    this.config = config;
    this.fetcher = SdkAuth._getFetcher(config.fetch);

    // auth endpoints
    this.ANONYMOUS_FLOW_URI = "/oauth/--projectKey--/anonymous/token";
    this.CUSTOMER_PASSWORD_FLOW_URI = "/oauth/--projectKey--/customers/token";
    this.BASE_AUTH_FLOW_URI = '/oauth/token';
    this.INTROSPECT_URI = '/oauth/introspect';
  }
  return _createClass(SdkAuth, [{
    key: "_process",
    value: function _process(request) {
      return this._performRequest(request).then(function (response) {
        return SdkAuth._handleResponse(request.uri, response);
      });
    }
  }, {
    key: "_performRequest",
    value: function _performRequest(request) {
      var uri = request.uri,
        body = request.body,
        basicAuth = request.basicAuth,
        authType = request.authType,
        headers = request.headers;
      var fetchHeaders = headers || {
        Authorization: "".concat(authType || DEFAULT_AUTH_TYPE, " ").concat(basicAuth),
        'Content-Length': JSON.stringify((body === null || body === void 0 ? void 0 : body.length) || 0),
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      var fetchRequest = {
        method: 'POST',
        headers: fetchHeaders,
        body: body
      };

      // use .call as a workaround for `TypeError: Failed to execute 'fetch' on 'Window': Illegal invocation`
      // error which occures in browser when using this class loaded by webpack and installed by yarn
      return this.fetcher.call(null, uri, fetchRequest);
    }
  }, {
    key: "_getRequestConfig",
    value: function _getRequestConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // eslint-disable-next-line prefer-object-spread
      var mergedConfig = Object.assign({}, this.config, config);
      if (config.scopes) mergedConfig.scopes = config.scopes;
      return mergedConfig;
    }
  }, {
    key: "anonymousFlow",
    value: function anonymousFlow() {
      var anonymousId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _config = this._getRequestConfig(config);
      var request = SdkAuth._buildRequest(_config, SdkAuth._enrichUriWithProjectKey(this.ANONYMOUS_FLOW_URI, _config.projectKey));
      if (anonymousId) request = SdkAuth._appendToRequestBody(request, {
        anonymous_id: anonymousId
      });
      return this._process(request);
    }
  }, {
    key: "clientCredentialsFlow",
    value: function clientCredentialsFlow() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _config = this._getRequestConfig(config);
      var request = SdkAuth._buildRequest(_config, this.BASE_AUTH_FLOW_URI);
      return this._process(request);
    }
  }, {
    key: "_passwordFlow",
    value: function _passwordFlow(credentials, config, url) {
      var _ref = credentials || {},
        username = _ref.username,
        password = _ref.password;
      var request = SdkAuth._buildRequest(config, url, 'password');
      request = SdkAuth._appendUserCredentialsToBody(request, username, password);
      return this._process(request);
    }
  }, {
    key: "customerPasswordFlow",
    value: function customerPasswordFlow(credentials) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _config = this._getRequestConfig(config);
      var url = SdkAuth._enrichUriWithProjectKey(this.CUSTOMER_PASSWORD_FLOW_URI, _config.projectKey);
      return this._passwordFlow(credentials, _config, url);
    }
  }, {
    key: "clientPasswordFlow",
    value: function clientPasswordFlow(credentials) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _config = this._getRequestConfig(config);
      return this._passwordFlow(credentials, _config, this.BASE_AUTH_FLOW_URI);
    }
  }, {
    key: "refreshTokenFlow",
    value: function refreshTokenFlow(token) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!token) throw new Error('Missing required token value');
      var _config = this._getRequestConfig(config);
      var request = SdkAuth._appendToRequestBody(SdkAuth._buildRequest(_config, this.BASE_AUTH_FLOW_URI, 'refresh_token'), {
        refresh_token: token
      });
      return this._process(request);
    }
  }, {
    key: "introspectToken",
    value: function introspectToken(token) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!token) throw new Error('Missing required token value');
      var _config = this._getRequestConfig(config);
      var request = SdkAuth._appendToRequestBody(SdkAuth._buildRequest(_config, this.INTROSPECT_URI), {
        token: token
      });
      return this._process(request);
    }
  }, {
    key: "customFlow",
    value: function customFlow(requestConfig) {
      var credentials = requestConfig.credentials,
        host = requestConfig.host,
        uri = requestConfig.uri,
        body = requestConfig.body,
        token = requestConfig.token,
        authType = requestConfig.authType,
        headers = requestConfig.headers;
      var _config = this._getRequestConfig({
        host: host,
        token: token,
        authType: authType,
        headers: headers
      });
      var request = SdkAuth._buildRequest(_config, uri);
      request.body = body || ''; // let user to build their own body

      if (credentials) request = SdkAuth._appendUserCredentialsToBody(request, credentials.username, credentials.password);
      return this._process(request);
    }
  }], [{
    key: "_getFetcher",
    value: function _getFetcher(fetcher) {
      if (!fetcher && typeof fetch === 'undefined') throw new Error('`fetch` is not available. Please pass in `fetch` as an option or have it globally available.');
      var fetchFunction;
      if (fetcher) {
        fetchFunction = fetcher;
      } else {
        // `fetcher` is set here rather than the destructuring to ensure fetch is
        // declared before referencing it otherwise it would cause a `ReferenceError`.
        // For reference of this pattern: https://github.com/apollographql/apollo-link/blob/498b413a5b5199b0758ce898b3bb55451f57a2fa/packages/apollo-link-http/src/httpLink.ts#L49
        /* istanbul ignore next */
        fetchFunction = fetch;
      }
      return fetchFunction;
    }
  }, {
    key: "_checkRequiredConfiguration",
    value: function _checkRequiredConfiguration(config) {
      if (!config) throw new Error('Missing required options');
      if (!config.host) throw new Error('Missing required option (host)');
      if (!config.credentials) throw new Error('Missing required option (credentials)');
      var _config$credentials = config.credentials,
        clientId = _config$credentials.clientId,
        clientSecret = _config$credentials.clientSecret;
      if (!(clientId && clientSecret)) throw new Error('Missing required credentials (clientId, clientSecret)');
    }
  }, {
    key: "_encodeClientCredentials",
    value: function _encodeClientCredentials(_ref2) {
      var clientId = _ref2.clientId,
        clientSecret = _ref2.clientSecret;
      var targetStr = "".concat(clientId, ":").concat(clientSecret);
      return typeof Buffer === 'undefined' ? btoa(targetStr) : Buffer.from(targetStr).toString('base64');
    }
  }, {
    key: "_getScopes",
    value: function _getScopes(scopes, projectKey) {
      return scopes ? scopes.join(' ') : [MANAGE_PROJECT, projectKey].filter(Boolean).join(':'); // generate a default scope manage_project:projectKey
    }
  }, {
    key: "_buildRequest",
    value: function _buildRequest(config, oauthUri) {
      var grantType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'client_credentials';
      var projectKey = config.projectKey,
        credentials = config.credentials,
        host = config.host,
        disableRefreshToken = config.disableRefreshToken,
        scopes = config.scopes,
        headers = config.headers;
      var scope = SdkAuth._getScopes(scopes, projectKey);
      var uri = host.replace(/\/$/, '') + oauthUri;
      var basicAuth = config.token || SdkAuth._encodeClientCredentials(credentials);
      var authType = config.authType || DEFAULT_AUTH_TYPE;
      var isNotRefreshTokenGrantType = grantType !== 'refresh_token';
      var queryParams = {
        grant_type: grantType
      };
      if (disableRefreshToken) {
        queryParams.refresh_token = false;
      }
      if (isNotRefreshTokenGrantType) {
        queryParams.scope = scope;
      }
      var initialBody = encode(queryParams);
      return {
        basicAuth: basicAuth,
        authType: authType,
        uri: uri,
        body: initialBody,
        headers: headers
      };
    }
  }, {
    key: "_appendToRequestBody",
    value: function _appendToRequestBody(request, toAppend) {
      var previousDecodedRequestBody = request.body ? decode(request.body) : {};
      var nextEncodedRequestBody = encode(_objectSpread2(_objectSpread2({}, previousDecodedRequestBody), toAppend));
      request.body = nextEncodedRequestBody;
      return request;
    }
  }, {
    key: "_createResponseError",
    value: function _createResponseError(_ref3, uri, statusCode) {
      var _ref3$message = _ref3.message,
        message = _ref3$message === void 0 ? 'Unexpected non-JSON error response' : _ref3$message,
        rest = _objectWithoutProperties(_ref3, _excluded);
      var errorMessage = statusCode === 404 ? "URI not found: ".concat(uri) : message;
      var ResponseError = getErrorByCode(statusCode);
      if (!ResponseError) ResponseError = getErrorByCode(0);
      return new ResponseError(errorMessage, rest);
    }
  }, {
    key: "_parseResponseJson",
    value: function _parseResponseJson(response) {
      return response.json().catch(function () {
        return {
          statusCode: response.status
        };
      });
    }
  }, {
    key: "_isErrorResponse",
    value: function _isErrorResponse(response) {
      return !response.status || response.status >= 400;
    }
  }, {
    key: "_calculateExpirationTime",
    value: function _calculateExpirationTime(expiresIn) {
      return Date.now() + expiresIn * 1000;
    }
  }, {
    key: "_enrichTokenResponse",
    value: function _enrichTokenResponse(response) {
      if (response.expires_in) {
        return _objectSpread2(_objectSpread2({}, response), {}, {
          // add a new property with expiration time in unixTimestamp format
          expires_at: SdkAuth._calculateExpirationTime(response.expires_in)
        });
      }
      return response;
    }
  }, {
    key: "_handleResponse",
    value: function _handleResponse(uri, response) {
      return SdkAuth._parseResponseJson(response).then(function (jsonResponse) {
        if (SdkAuth._isErrorResponse(response)) throw SdkAuth._createResponseError(jsonResponse, uri, response.status);
        return SdkAuth._enrichTokenResponse(jsonResponse);
      });
    }
  }, {
    key: "_appendUserCredentialsToBody",
    value: function _appendUserCredentialsToBody(request, username, password) {
      if (!(username && password)) throw new Error('Missing required user credentials (username, password)');
      return SdkAuth._appendToRequestBody(request, {
        username: username,
        password: password
      });
    }
  }, {
    key: "_enrichUriWithProjectKey",
    value: function _enrichUriWithProjectKey(uri, projectKey) {
      if (!projectKey) throw new Error('Missing required option (projectKey)');
      return uri.replace('--projectKey--', projectKey);
    }
  }]);
}();

var TokenProvider = /*#__PURE__*/function () {
  // Set flowtype annotations

  function TokenProvider(_ref) {
    var sdkAuth = _ref.sdkAuth,
      fetchTokenInfo = _ref.fetchTokenInfo,
      onTokenInfoChanged = _ref.onTokenInfoChanged,
      onTokenInfoRefreshed = _ref.onTokenInfoRefreshed;
    var tokenInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, TokenProvider);
    if (!sdkAuth) throw new Error('Property "sdkAuth" was not provided');
    if (tokenInfo) TokenProvider._validateTokenInfo(tokenInfo);
    this.onTokenInfoChanged = onTokenInfoChanged;
    this.onTokenInfoRefreshed = onTokenInfoRefreshed;
    this.fetchTokenInfo = fetchTokenInfo;
    this.sdkAuth = sdkAuth;
    this.tokenInfo = tokenInfo;
    this.fetchTokenInfoPromise = null;
    this.refreshTokenFlowPromise = null;
  }
  return _createClass(TokenProvider, [{
    key: "_performFetchTokenInfo",
    value: function _performFetchTokenInfo() {
      var _this = this;
      if (!this.fetchTokenInfo) return Promise.reject(new Error('Method "fetchTokenInfo" was not provided'));

      // do not run fetchTokenInfo more than once at any given time and cache the result
      if (this.fetchTokenInfoPromise) return this.fetchTokenInfoPromise;
      this.fetchTokenInfoPromise = Promise.resolve(this.fetchTokenInfo(this.sdkAuth));
      return this.fetchTokenInfoPromise.then(function (tokenInfo) {
        _this.fetchTokenInfoPromise = null;
        return tokenInfo;
      }).catch(function (error) {
        _this.fetchTokenInfoPromise = null;
        throw error;
      });
    }
  }, {
    key: "_performRefreshTokenFlow",
    value: function _performRefreshTokenFlow(refreshToken) {
      var _this2 = this;
      // run refreshTokenFlow only once when multiple requests comes at the same time
      if (this.refreshTokenFlowPromise) return this.refreshTokenFlowPromise;
      this.refreshTokenFlowPromise = this.sdkAuth.refreshTokenFlow(refreshToken);
      return this.refreshTokenFlowPromise.then(function (refreshTokenInfo) {
        _this2.refreshTokenFlowPromise = null;
        return refreshTokenInfo;
      }).catch(function (error) {
        _this2.refreshTokenFlowPromise = null;
        throw error;
      });
    }
  }, {
    key: "_refreshToken",
    value: function _refreshToken(oldTokenInfo) {
      var _this3 = this;
      var newTokenInfo;
      if (!(oldTokenInfo !== null && oldTokenInfo !== void 0 && oldTokenInfo.refresh_token) && !this.fetchTokenInfo) return Promise.reject(new Error('Property "refresh_token" and "fetchTokenInfo" method are missing'));

      // perform refreshTokenFlow if we have refresh token otherwise call getTokenInfo method
      var newTokenPromise = oldTokenInfo !== null && oldTokenInfo !== void 0 && oldTokenInfo.refresh_token ? this._performRefreshTokenFlow(oldTokenInfo.refresh_token) : this._performFetchTokenInfo();
      return newTokenPromise.then(function (tokenInfo) {
        var _this3$onTokenInfoRef;
        newTokenInfo = tokenInfo;
        if (oldTokenInfo !== null && oldTokenInfo !== void 0 && oldTokenInfo.refresh_token) newTokenInfo.refresh_token = oldTokenInfo.refresh_token;
        return (_this3$onTokenInfoRef = _this3.onTokenInfoRefreshed) === null || _this3$onTokenInfoRef === void 0 ? void 0 : _this3$onTokenInfoRef.call(_this3, newTokenInfo, oldTokenInfo);
      }).then(function () {
        return _this3.setTokenInfo(newTokenInfo);
      });
    }

    /**
     * Set current token info to null
     */
  }, {
    key: "invalidateTokenInfo",
    value: function invalidateTokenInfo() {
      this.tokenInfo = null;
    }

    /**
     * Method will return tokenInfo or if it is not provided it will call fetchTokenInfo() method
     * for retrieving the first tokenInfo
     * @returns {Promise.<TokenInfo>}
     */
  }, {
    key: "getTokenInfo",
    value: function getTokenInfo() {
      if (this.tokenInfo && !TokenProvider._isTokenExpired(this.tokenInfo)) return Promise.resolve(this.tokenInfo);

      // $FlowFixMe[incompatible-call]: _refreshToken method will fetch new tokenInfo if not provided
      return this._refreshToken(this.tokenInfo);
    }
  }, {
    key: "setTokenInfo",
    value: function setTokenInfo(tokenInfo) {
      var _this$onTokenInfoChan;
      TokenProvider._validateTokenInfo(tokenInfo);
      this.tokenInfo = tokenInfo;
      return Promise.resolve((_this$onTokenInfoChan = this.onTokenInfoChanged) === null || _this$onTokenInfoChan === void 0 ? void 0 : _this$onTokenInfoChan.call(this, tokenInfo)).then(function () {
        return tokenInfo;
      });
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.getTokenInfo().then(function (tokenInfo) {
        return tokenInfo.access_token;
      });
    }
  }], [{
    key: "_validateTokenInfo",
    value: function _validateTokenInfo(tokenInfo) {
      if (!tokenInfo.access_token && !tokenInfo.refresh_token) throw new Error('At least one of "access_token" or "refresh_token" properties has to be provided');
    }
  }, {
    key: "_isTokenExpired",
    value: function _isTokenExpired(tokenInfo) {
      if (!tokenInfo || !tokenInfo.access_token || !tokenInfo.expires_at) return true;

      // token is expired if current time is bigger than expiration time minus some offset
      // NOTE: all timezones use same place of unix timestamp origin
      return Date.now() >= (tokenInfo.expires_at || 0) - EXPIRATION_OFFSET;
    }
  }]);
}();

export { TokenProvider, SdkAuth as default };
